import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const ResultsHeader = ({ totalResults, sortBy, onSortChange }) => {
  const sortOptions = [
    { value: 'relevance', label: 'Most Relevant' },
    { value: 'availability', label: 'Soonest Available' },
    { value: 'rating', label: 'Highest Rated' },
    { value: 'experience', label: 'Most Experienced' },
    { value: 'proximity', label: 'Closest Location' }
  ];

  return (
    <div className="flex items-center justify-between gap-4 mb-6">
      <div className="flex items-center gap-2 text-foreground">
        <Icon name="Users" size={20} className="text-primary" />
        <span className="font-medium">
          {totalResults} {totalResults === 1 ? 'Helper' : 'Helpers'} Found
        </span>
      </div>
      <div className="w-64">
        <Select
          options={sortOptions}
          value={sortBy}
          onChange={onSortChange}
          placeholder="Sort by..."
        />
      </div>
    </div>
  );
};

export default ResultsHeader;